import { ProductForm } from "../Products";
import { Product } from "../../../../types/api/Product";
import { Nullable } from "../../../../utils/Nullable";

export function apiToForm(apiProduct: Product) {
  return {
    id: apiProduct.id,
    name: apiProduct.name,
    description: apiProduct.description || "",
    order_unit: apiProduct.order_unit?.id || "",
    retail_units: apiProduct.quantity_per_unit || "",
    state: apiProduct.state?.id || "",
    // divide by 100 and keep two decimal places
    price: (
      Math.round(Number(apiProduct.unit_price_in_cents)) / 100
    ).toString(),
    msrp: (Math.round(Number(apiProduct.msrp_in_cents)) / 100).toString(),
    stock_keeping_unit: apiProduct.stock_keeping_unit || "",
    minimum_order_quantity: apiProduct.minimum_order_quantity || 1,
    universal_product_code: apiProduct.universal_product_code || "",
    inventory_count: apiProduct.inventory_count || "",
    weight: apiProduct.product_physical_measurements.weight || "",
    weight_unit: apiProduct.product_physical_measurements.weight_unit?.id || "",
    length: apiProduct.product_physical_measurements.length || "",
    width: apiProduct.product_physical_measurements.width || "",
    height: apiProduct.product_physical_measurements.height || "",
    dimension_unit:
      apiProduct.product_physical_measurements.dimension_unit?.id || "",
    media: apiProduct.media,
  };
}

export function formToApi(
  id: Nullable<string>,
  organizationId: string,
  form: ProductForm,
  orderUnits: { id: string; unit: string }[],
  productStates: { id: string; state: string }[],
  weightUnits: { id: string; unit: string }[],
  dimensionUnits: { id: string; unit: string }[]
) {
  return {
    id: id,
    description: form.description,
    stock_keeping_unit: form.stock_keeping_unit,
    media: form.media,
    minimum_order_quantity: form.minimum_order_quantity,
    name: form.name,
    order_unit: orderUnits.find((value) => value.id === form.order_unit),
    organization: organizationId,
    quantity_per_unit: form.retail_units !== "" ? form.retail_units : null,
    unit_price_in_cents: Math.round(Number(form.price) * 100),
    msrp_in_cents: Math.round(Number(form.msrp) * 100),
    state: productStates.find((value) => value.id === form.state),
    universal_product_code: form.universal_product_code,
    tags: [],
    product_physical_measurements: {
      weight: form.weight !== "" ? form.weight : null,
      weight_unit: weightUnits.find((value) => value.id === form.weight_unit),
      height: form.height !== "" ? form.height : null,
      width: form.width !== "" ? form.width : null,
      length: form.length !== "" ? form.length : null,
      dimension_unit: dimensionUnits.find(
        (value) => value.id === form.dimension_unit
      ),
    },
  };
}
